import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/cultural-organizations',
    name: 'page-cultural-organizations',
    component: () => import('@/pages/culturalOrganizations'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/cultural-organization/new',
    name: 'page-cultural-organization-new',
    component: () => import('@/pages/culturalOrganization'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/cultural-organization/:id',
    name: 'page-cultural-organization',
    component: () => import('@/pages/culturalOrganization'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
